const TechAppTermsAndConditions = () => {
  return (
    <main className="min-h-screen" style={{willChange: 'scroll-position'}}>
      <section>
        <div className="w-full px-6 lg:px-8" style={{contain: 'layout style'}}>
          <div className="py-8">
            <h6 className={styles.dateText}>Last Updated 10/04/2023</h6>
            <h2 className={styles.mainTitle}>Terms & Conditions</h2>

            <h2 className={styles.sectionHeader}>LEGAL</h2>
            <p className={styles.paragraph}>
              PLEASE READ THE TERMS OF USE CAREFULLY BEFORE SIGNING UP TO BECOME A Fixt TECHNICIAN. BY SUBMITTING THE
              FORM, THE TECHNICIAN (WHICH INCLUDES ANY USER OF THE APPLICATION) (&ldquo;YOU&rdquo;) AGREE TO BECOME
              BOUND BY THE TERMS OF USE. THESE TERMS OF USE APPLY TO YOU (INCLUDING ALL TECHNICIANS AND USERS THAT
              CONTRIBUTE CONTENT, INFORMATION, AND OTHER MATERIALS OR SERVICES ON THE SITE). IF YOU DO NOT
              UNCONDITIONALLY AGREE TO ALL THE TERMS AND CONDITIONS OF THE TERMS OF USE, YOU DO NOT HAVE ANY RIGHT TO
              USE THE SERVICE OR THE SITE. Fixt&rsquo;s ACCEPTANCE IS EXPRESSLY CONDITIONED UPON YOUR ASSENT TO ALL THE
              TERMS AND CONDITIONS OF THIS AGREEMENT; YOUR CONTINUED USE OF OR ACCESS TO THE SERVICE AND/OR SERVICES
              SHALL BE DEEMED ACCEPTANCE OF THE TERMS OF USE.
            </p>

            <h2 className={styles.sectionHeader}>ACCEPTANCE OF TERMS</h2>
            <p className={styles.paragraph}>
              The following terms and conditions govern all use of the Fixt Technician Application (the
              &ldquo;Site&rdquo;) and the services available on or facilitated by the Site (the &ldquo;Service&rdquo;).
              The Service is owned and operated by SOSI-Fixt, Inc. (&ldquo;Fixt&rdquo;). The Service is offered to You
              subject to acceptance without modification by You of all of the terms and conditions contained herein (the
              &ldquo;Terms of Use&rdquo;) and all other operating rules, policies and procedures that may be published
              from time to time on the Site by Fixt.
            </p>

            <p className={styles.paragraph}>
              The Service is available only to individuals who are at least 18 years and are fully able and competent to
              enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in
              these Terms of Use, and to abide by and comply with these Terms of Use. Fixt may, in its sole discretion,
              refuse to offer the Service to any person or entity and change its eligibility criteria at any time.
            </p>

            <p className={styles.paragraph}>
              Fixt reserves the right, at its sole discretion, to modify or replace any of the Terms of Use at any time,
              by posting the modified Terms of Use or other policies or guidelines on the Site, and sending You an email
              notifying You of the nature of the modifications and a link to the modified document on the Site so that
              You may review it. It is Your responsibility to check the Terms of Use periodically for changes. Your
              continued use of the Service following the posting or notification of any changes to the Terms of Use
              constitutes Your acceptance of those changes and Your agreement to abide and be bound by the Terms of Use,
              as amended. If at any time You choose not to accept the Terms of Use, including following receipt of
              notification of any modifications hereto, then please do not use the Site or the Service.
            </p>

            <h2 className={styles.sectionHeader}>PRICE</h2>
            <p className={styles.paragraph}>
              We will provide the price of the services for each opportunity we send. This price is final, and no
              modification or adjustment of the stated price may be made by You without the express written consent of
              Fixt. Repairs are not valid unless accepted in the Fixt Technician App by You, and Fixt will not recognize
              Your acceptance based on verbal orders. Your commencement of work on the services subject to each repair
              request shall be deemed an effective mode of acceptance of price offered and set by Fixt.
            </p>

            <h2 className={styles.sectionHeader}>RULES AND CONDUCT</h2>
            <p className={styles.paragraph}>
              As a condition of use, You promise not to use the Service for any purpose that is prohibited by the Terms
              of Use. The Service (including, without limitation, any Content or User Submissions (both as defined
              below)) is provided only for Your own personal use. For purposes of the Terms of Use,
              &ldquo;Content&rdquo; includes, without limitation, any video, audio, information, data, text, software,
              images, photographs, scripts, graphics, logos, interactive features, and other works of authorship in any
              form, medium or technology now known or later developed, which is generated, provided, or otherwise made
              accessible by Fixt on or through the Service. User Submissions shall mean pictures, audio, video,
              documents, reviews, ratings, ideas, notes, concepts, or creative suggestions provided by You (&ldquo;User
              Submissions&rdquo;).
            </p>

            <p className={styles.paragraphShort}>
              By way of example, and not as a limitation, You shall not (or permit others to) either (a) take any action
              or (b) upload, download, post, submit or otherwise distribute or facilitate distribution of any Content,
              User Submissions, or other information using any communications service or other service available on or
              through the Service, that:
            </p>

            <ul className={styles.list}>
              <li className={styles.listItem}>
                infringes any patent, trademark, service mark, trade secret, copyright, right of privacy or publicity or
                other right of any other person or entity;
              </li>
              <li className={styles.listItem}>
                includes video or a photograph of another person or an identifiable location that you have posted
                without that person&rsquo;s or the owner of such location&rsquo;s consent;
              </li>
              <li className={styles.listItem}>
                is unlawful, threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of
                another&rsquo;s privacy, tortious, obscene, offensive, sexually explicit or profane, or depicts nudity,
                unlawful activities, death or violence, or encourages conduct that could constitute a criminal offense;
              </li>
              <li className={styles.listItem}>
                constitutes unauthorized or unsolicited advertising, junk or bulk email (i.e., &ldquo;spamming&rdquo;);
              </li>
              <li className={styles.listItem}>
                involves commercial activities and/or sales without Fixt&apos;s prior written consent, such as contests,
                sweepstakes, barter, advertising, or pyramid schemes;
              </li>
              <li className={styles.listItem}>
                advertises to, or solicits, any other user of the Service to buy or sell any products or services
                through the Service other than as incorporated in User Submissions which are otherwise in accordance
                with these Terms of Use;
              </li>
              <li className={styles.listItem}>
                displays an advertisement, or accepts payment or anything of value from a third person in exchange for
                your performing any activity on or through the Service on behalf of that person, such as posting
                commercial content, or posting blogs or bulletins with a commercial purpose;
              </li>
              <li className={styles.listItem}>
                contains software viruses or any other computer codes, files, or programs that are designed or intended
                to disrupt, damage, limit or interfere with the proper function of any software, hardware, or
                telecommunications equipment or to damage or obtain unauthorized access to any system, data or other
                information of Fixt Inc. or any third party; or
              </li>
              <li className={styles.listItem}>
                impersonates any person or entity, including any employee or representative of Fixt.
              </li>
            </ul>

            <p className={styles.paragraphShort}>Additionally, You shall not:</p>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                take any action that imposes or may impose (as determined by Fixt in its sole discretion) an
                unreasonable or disproportionately small strain on Fixt&apos;s infrastructure;
              </li>
              <li className={styles.listItem}>
                interfere or attempt to interfere with the proper working of the Service or any activities conducted on
                the Service; or
              </li>
              <li className={styles.listItem}>
                bypass any measures Fixt may use to prevent or restrict access to the Service (or other accounts,
                computer systems or networks connected to the Service);
              </li>
              <li className={styles.listItem}>self-promote Your services or business to Fixt customers; or</li>
              <li className={styles.listItem}>
                discuss payment terms or accept any form of payment from a Fixt customer.
              </li>
            </ul>

            <p className={styles.paragraphShort}>You shall not (directly or indirectly):</p>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                decipher, decompile, disassemble, reverse engineer or otherwise attempt to derive any source code or
                underlying ideas or algorithms of any part of the Service, except to the limited extent applicable laws
                specifically prohibit such restriction;
              </li>
              <li className={styles.listItem}>
                modify, translate, or otherwise create derivative works of any part of the Service or as explicitly
                provided on the Site; or
              </li>
              <li className={styles.listItem}>
                copy, rent, lease, distribute, or otherwise transfer any or the rights that you receive hereunder.
              </li>
            </ul>

            <p className={styles.paragraph}>
              You shall abide by all applicable local, state, national and international laws and regulations.
            </p>

            <h2 className={styles.sectionHeader}>REGISTRATION</h2>
            <p className={styles.paragraph}>
              In order to access some features of the Site, You will have to create an account. You must submit a valid
              email address and select a password during the registration process. You may never use another&apos;s
              account without permission. When creating Your account, You must provide accurate and complete
              information. Failure to do so shall constitute a breach of the Terms of Use, which may result in immediate
              termination of Your Fixt account.
            </p>

            <p className={styles.paragraphShort}>You shall not:</p>

            <ul className={styles.list}>
              <li className={styles.listItem}>
                select or use as a Fixt account name the name of another person with the intent to impersonate that
                person;
              </li>
              <li className={styles.listItem}>
                use as a Fixt account name a name that is subject to any rights of a person other than You without
                appropriate authorization; or
              </li>
              <li className={styles.listItem}>
                use as a Fixt account name a name that is otherwise offensive, vulgar or obscene.
              </li>
            </ul>

            <p className={styles.paragraph}>
              Fixt reserves the right to refuse registration of, or cancel a Fixt account in its sole discretion. You
              are solely responsible for activity that occurs on Your account and shall be responsible for maintaining
              the confidentiality of Your Fixt password. You may never permit anyone else to use your account. You will
              immediately notify Fixt in writing of any unauthorized use of Your account, or other account related
              security breach of which You are aware.
            </p>

            <h2 className={styles.sectionHeader}>COPYRIGHT & TRADEMARKS</h2>
            <p className={styles.paragraph}>
              Unless otherwise indicated, the Terms of Use and all Content provided by Fixt are the property of Fixt and
              all rights are reserved. All trademarks, service marks and trade names of Fixt used in the Site or the
              Service are trademarks or registered trademarks of Fixt. Any use, including but not limited to the
              reproduction, distribution, display or transmission of the marks or contents of this site is strictly
              prohibited, unless authorized by Fixt. You further agree not to change or delete any proprietary notices
              from materials downloaded from the site. The names of actual companies and products mentioned on the Site
              may be the trademarks or service marks of their respective owners. Note that iPhone, iPod, and iPad are
              all trademarks of Apple Inc., and of Apple Inc. alone.
            </p>

            <h2 className={styles.sectionHeader}>AFFILIATION</h2>
            <p className={styles.paragraph}>
              Fixt is an independent service provider. Fixt, its affiliates, and its affiliates&apos; employees,
              contractors, directors, suppliers and representatives, are in no way, shape, or form affiliated with any
              Original Equipment Manufacturer (&quot;OEM&quot;).
            </p>
            <p className={styles.paragraph}>
              The Service may permit You to link to other websites or resources on the Internet, and other websites or
              resources may contain links to the Site. These other websites are not under Fixt&apos;s control, and You
              acknowledge that Fixt is not responsible or liable for the content, functions, accuracy, legality,
              appropriateness or any other aspect of such websites or resources. The inclusion of any such link does not
              imply endorsement by Fixt or any association with its operators. You further acknowledge and agree that
              Fixt shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged
              to be caused by or in connection with the use of or reliance on any such Content, goods or services
              available on or through any such website or resource.
            </p>

            <h2 className={styles.sectionHeader}>WARRANTY DISCLAIMER</h2>
            <p className={styles.paragraph}>
              THE SERVICE IS PROVIDED TO YOU &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; AND IS WITHOUT WARRANTY OF
              ANY KIND, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE,
              NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, AND ANY WARRANTIES IMPLIED BY ANY
              COURSE OF PERFORMANCE OR USAGE OF TRADE, ALL OF WHICH ARE EXPRESSLY DISCLAIMED. Fixt MAKES NO WARRANTIES
              OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE&apos;S CONTENT OR THE CONTENT OF ANY
              SITES LINKED TO THE SITE AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY:
            </p>

            <ul className={styles.list}>
              <li className={styles.listItem}>ERRORS, MISTAKES, OR INACCURACIES OF CONTENT;</li>
              <li className={styles.listItem}>
                PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF
                THE SERVICE;
              </li>
              <li className={styles.listItem}>
                CONSEQUENCES OF USING THE SITE OR YOUR EXPOSURE TO ANY CONTENT OR USER SUBMISSIONS ON THE SITE;
              </li>
              <li className={styles.listItem}>
                UNAUTHORIZED DISCLOSURE OF IMAGE, INFORMATION OR DATA THAT RESULTS FROM THE UPLOAD, DOWNLOAD OR STORAGE
                OF USER SUBMISSIONS; OR
              </li>
              <li className={styles.listItem}>
                STATISTICS PROVIDED TO YOU OR OTHER USERS OF THE SERVICE, INCLUDING, BUT NOT LIMITED TO, SITE ACTIVITY,
                SEARCH RESULTS, OR CONTENT VIEWS. Fixt IS NOT RESPONSIBLE FOR ANY SEARCH RESULTS OR RANKINGS OR THE
                ADDITION OF OR CHANGE TO ASSOCIATED METADATA OF CONTENT ON THE SITE.
              </li>
            </ul>

            <p className={styles.paragraphShort}>
              Fixt, AND ITS DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, PARTNERS AND CONTENT PROVIDERS DO NOT WARRANT THAT:
            </p>

            <ul className={styles.list}>
              <li className={styles.listItem}>
                THE SERVICE WILL BE SECURE OR AVAILABLE AT ANY PARTICULAR TIME OR LOCATION;
              </li>
              <li className={styles.listItem}>ANY DEFECTS OR ERRORS WILL BE CORRECTED;</li>
              <li className={styles.listItem}>
                ANY CONTENT OR SOFTWARE AVAILABLE AT OR THROUGH THE SERVICE IS FREE OF VIRUSES OR OTHER HARMFUL
                COMPONENTS;
              </li>
              <li className={styles.listItem}>
                THE SITE OR THE SERVICE WILL OPERATE IN COMBINATION WITH ANY OTHER HARDWARE, SOFTWARE, SYSTEM OR DATA;
                OR
              </li>
              <li className={styles.listItem}>THE RESULTS OF USING THE SERVICE WILL MEET YOUR REQUIREMENTS.</li>
            </ul>

            <h2 className={styles.sectionHeader}>TECHNICIAN WARRANTY</h2>
            <p className={styles.paragraph}>
              You warrant to Fixt and its customers that all repairs and parts offered to Fixt or Fixt&apos;s customers
              shall be free of defects in materials and workmanship for a period of 12-months from the date of repair.
              In the case of Software, the warranty applies to factory restores, backups, unlocks, performed by You.
            </p>
            <p className={styles.paragraph}>
              If the unit should malfunction (including any breach of warranty for repairs, parts, or software), You
              must honor such warranty. You will go out to diagnose the repair immediately upon notice of defect. Upon
              examination by You, if the unit is found to be defective it will be repaired or replaced at no charge. For
              the avoidance of doubt warranty to X, however, does not apply to defects resulting from any action of the
              customer, including but not limited to mishandling, physical damage, water damage, improper interfacing,
              operation outside of design limits, repair by someone other than Fixt, use of any other product other than
              Fixt products, or unauthorized modification.
            </p>

            <h2 className={styles.sectionHeader}>LIMITATION OF LIABILITY</h2>
            <p className={styles.paragraphShort}>
              IN NO EVENT SHALL Fixt, NOR ITS DIRECTORS, EMPLOYEES, AGENTS, PARTNERS, SUPPLIERS OR CONTENT PROVIDERS, BE
              LIABLE TO YOU UNDER CONTRACT, TORT, STRICT LIABILITY, NEGLIGENCE OR ANY OTHER LEGAL THEORY WITH RESPECT TO
              THE SERVICES:
            </p>

            <ul className={styles.list}>
              <li className={styles.listItem}>
                FOR ANY LOST PROFITS OR SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES OF ANY KIND
                WHATSOEVER, SUBSTITUTE GOODS OR SERVICES ARISING FROM
                <ul className={styles.nestedList}>
                  <li className={styles.listItem}>ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, OR</li>
                  <li className={styles.listItem}>
                    PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO THE SITE
                    AND USE OF THE SERVICE;
                  </li>
                </ul>
              </li>
              <li className={styles.listItem}>
                FOR ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE (REGARDLESS OF THE SOURCE OF ORIGINATION); OR
              </li>
              <li className={styles.listItem}>FOR ANY DIRECT DAMAGES IN EXCESS OF (IN THE AGGREGATE) $10 (U.S.).</li>
            </ul>

            <h2 className={styles.sectionHeader}>INDEMNIFICATION</h2>
            <p className={styles.paragraphShort}>
              You shall defend, indemnify, and hold harmless Fixt, its affiliates and each of its, and its
              affiliates&apos; employees, contractors, directors, suppliers and representatives from all liabilities,
              claims, and expenses, including reasonable attorneys&apos; fees and legal expenses, that arise from:
            </p>

            <ul className={styles.list}>
              <li className={styles.listItem}>Your use or misuse of, or access to, the Service;</li>
              <li className={styles.listItem}>Your violation of the Terms of Use;</li>
              <li className={styles.listItem}>Your willful misconduct or negligent acts;</li>
              <li className={styles.listItem}>Bodily injury or property damage caused by Your acts; or,</li>
              <li className={styles.listItem}>
                The infringement by you, or any third party using your account, of any intellectual property, privacy,
                publicity or other right of any person or entity.
              </li>
            </ul>

            <p className={styles.paragraph}>
              Fixt reserves the right to assume the exclusive defense and control of any matter otherwise subject to
              indemnification by You, in which event You will assist and cooperate with Fixt in asserting any available
              defenses. This obligation survives indefinitely the termination and/or expiration of these Terms of Use
              and/or Your status as a technician or ability to use the Site
            </p>

            <h2 className={styles.sectionHeader}>TERMINATION</h2>
            <p className={styles.paragraph}>
              Fixt may terminate the Service or your access to all or any part of the Service at any time, with or
              without cause, with or without notice, effective immediately. If you wish to terminate your account,
              contact us. All provisions of the Terms of Use that by their nature should survive termination shall
              survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity
              and limitations of liability.
            </p>

            <h2 className={styles.sectionHeader}>NOTICE</h2>
            <p className={styles.paragraph}>
              Fixt may deliver notice to You by means of telephone call, e-mail, a general notice through the site, or
              by other reliable method to the address You have provided to Fixt. All notices under the Terms of Use will
              be in writing and will be deemed to have been duly given when received, if personally delivered or sent by
              certified or registered mail, return receipt requested; when receipt is electronically confirmed, if
              transmitted by facsimile or e-mail; or the day after it is sent, if sent for next day delivery by
              recognized overnight delivery service. In the case of Fixt, all notices shall be sent via mail to:
            </p>

            <div className={styles.highlightBox}>
              <p className={styles.highlightText}>ASSURANT</p>
              <p className={styles.listItem}>ATN: SOSI-Fixt, Inc.</p>
              <p className={styles.listItem}>S260 Interstate N Cir SE,</p>
              <p className={styles.listItem}>Atlanta, GA 30339.</p>
            </div>

            <h2 className={styles.sectionHeader}>DISPUTE RESOLUTION</h2>
            <p className={styles.paragraph}>
              A printed version of the Terms of Use and of any notice given in electronic form shall be admissible in
              judicial or administrative proceedings based upon or relating to the Terms of Use to the same extent and
              subject to the same conditions as other business documents and records originally generated and maintained
              in printed form. You and Fixt agree that any cause of action arising out of or related to the Service or
              the Site must commence within one (1) year after the cause of action arose; otherwise, such cause of
              action is permanently barred. The Terms of Use shall be governed by and construed in accordance with the
              laws of the State of Florida, excluding its conflicts of law rules, and all applicable federal laws. You
              expressly agree that the exclusive jurisdiction and venue for any claim or action arising out of or
              relating to the Terms of Use or Your use of this Site or Services shall be only the state and county of
              Dade County, Florida, and You further agree and submit to the exercise of personal jurisdiction and venue
              therein for the purpose of litigating any such claim or action. Use of the Service is not authorized in
              any jurisdiction that does not give effect to all provisions of the Terms of Use, including without
              limitation, this section. Any dispute arising out of or relating to this Agreement shall be settled by one
              arbitrator in accordance with the rules of the American Arbitration Association. In the event an agreement
              cannot be reached as to the arbitrator, either party may petition a court of competent jurisdiction to
              appoint a neutral arbitrator. Each party shall be responsible for its own costs and expenses, but the
              costs and expenses of the arbitrator shall be shared equally by the parties.
            </p>

            <h2 className={styles.sectionHeader}>MISCELLANEOUS</h2>
            <p className={styles.paragraph}>
              The Terms of Use are the entire agreement between You and Fixt with respect to the Service and use of this
              Site, and supersede all prior or contemporaneous communications and proposals (whether oral, written or
              electronic) between You and Fixt with respect to this Site or any other of the subject matter hereof. If
              any provision of the Terms of Use is found to be unenforceable or invalid, that provision will be limited
              or eliminated to the minimum extent necessary so that the Terms of Use will otherwise remain in full force
              and effect and enforceable. No failure of Fixt or the Site to enforce any of its rights under these Terms
              of Use will act as a waiver of such rights. The Terms of Use are personal to You, and are not assignable,
              transferable or sublicensable by You except with Fixt&apos;s prior written consent. Fixt may assign,
              transfer or delegate any of its rights and obligations hereunder without consent. No agency, partnership,
              joint venture, or employment relationship is created as a result of the Terms of Use and neither party has
              any authority of any kind to bind the other in any respect. You acknowledge that You will be performing
              services as an independent contractor and not an employee of Fixt. In any action or proceeding to enforce
              rights under the Terms of Use, the Fixt will be entitled to recover costs and attorney&apos;s&apos; fees.
            </p>
            <p className={styles.paragraph}>
              This Agreement was entered into at arm&apos;s-length, without duress or coercion, and is to be interpreted
              as an agreement between two parties of equal bargaining strength. Both You and Fixt agree that this
              Agreement is clear and unambiguous as to its terms, and that no other evidence will be used or admitted to
              alter or explain the terms of this Agreement, but that it will be interpreted based on the language in
              accordance with the purposes for which it is entered into.
            </p>

            <h2 className={styles.sectionHeader}>ACKNOWLEDGMENT AND AUTHORIZATION FOR BACKGROUND CHECK</h2>
            <p className={styles.paragraph}>
              You hereby authorize the obtaining of &quot;consumer reports&quot; and/or &quot;investigative consumer
              reports&quot; by Fixt at any time after receipt of this authorization and throughout the term of this
              Agreement. To this end, You hereby authorize, without reservation, any law enforcement agency,
              administrator, state or federal agency, institution, school or university (public or private), information
              service bureau, employer, or insurance company to furnish any and all background information requested by
              Fixt or any third party designated by Fixt. I understand that the results of this investigation may be
              used in decisions about my status as a contractor for Fixt, where legally permissible. I agree that an
              email or facsimile (&quot;fax&quot;), electronic or photographic copy of this Authorization shall be as
              valid as the original.
            </p>
            <p className={styles.paragraph}>
              You will also receive a copy via e-mail of the following documents entitled A SUMMARY OF YOUR RIGHTS UNDER
              THE FAIR CREDIT REPORTING ACT and the DISCLOSURE AND AUTHORIZATION FOR BACKGROUND CHECK for Your review
              and record keeping.
            </p>
            <p className={styles.paragraph}>
              California applicants only: Under California Civil Code section 1786.22, You are entitled to find out what
              is in the CRA&apos;s consumer report on You with proper identification, as follows:
            </p>
            <p className={styles.paragraph}>
              In person, by visual inspection of Your consumer report during normal business hours and on reasonable
              notice. You also may request a copy of the information in person. The CRA may not charge You more than the
              actual copying costs for providing You with a copy of Your consumer report. A summary of all information
              contained in the CRA consumer report on You that is required to be provided by the California Civil Code
              will be provided to You via telephone, if You have made a written request, with proper identification, for
              telephone disclosure, and the toll charge, if any, for the telephone call is prepaid by or charged
              directly to You.
            </p>
            <p className={styles.paragraph}>
              By requesting a copy be sent to a specified addressee by certified mail. CRAs complying with requests for
              certified mailings shall not be liable for disclosures to third parties caused by mishandling of mail
              after such mailings leave the CRAs.
            </p>
            <p className={styles.paragraph}>
              New York applicants only: Upon request, You will be informed whether or not a consumer report was
              requested by Fixt, and if such report was requested, informed of the name and address of the consumer
              reporting agency that furnished the report. You have the right to inspect and receive a copy of any
              investigative consumer report requested by Fixt by contacting the consumer reporting agency identified
              above directly. By signing below, You acknowledge receipt of Article 23-A of the New York Correction Law.
            </p>
            <p className={styles.paragraph}>
              Washington State applicants only: You also have the right to request from the consumer reporting agency a
              written summary of Your rights and remedies under the Washington Fair Credit Reporting Act.
            </p>
            <p className={styles.paragraph}>
              &quot;Proper Identification&quot; includes documents such as a valid driver&apos;s license, social
              security account number, military identification card, and credit cards. Only if You cannot identify
              Yourself with such information may the CRA require additional information concerning Your engagement as a
              contractor and personal or family history in order to verify Your identity. The CRA will provide trained
              personnel to explain any information furnished to You and will provide a written explanation of any coded
              information contained in files maintained on You. This written explanation will be provided whenever a
              consumer report is provided to You for visual inspection. You may be accompanied by one other person of
              Your choosing, who must furnish reasonable identification. An CRA may require You to furnish a written
              statement granting permission to the CRA to discuss Your consumer reporting such person&apos;s presence.
            </p>

            <p className={styles.paragraph}>
              1. You understand and agree that Fixt will perform a background search of You prior to providing You with
              access to the Software as a condition precedent. Your connection with Customers through the Software is
              conditioned on a satisfactory result of a background check. Fixt may refuse to provide You access to the
              Software based upon any reason, including, but not limited to, the result of a background search or any
              other right provided to Fixt under the other terms of these Terms and Conditions. You agree to provide
              Fixt with any and all information needed in order for Fixt to perform the background search, pursuant to
              these Terms and Conditions.
            </p>
            <p className={styles.paragraph}>
              2. Fixt will inform You of the results of its background check and what Fixt plans to do (reject or
              utilize You as an independent contractor for services.) Background check providers may give You a copy of
              their results. Fixt conducts a background check on all technicians who pass through the Skills Assessment
              phase without discriminating against certain individuals. Fixt will give You reasonable information needed
              to dispute a report or address any issues their background check may bring up.
            </p>
            <p className={styles.paragraph}>
              3. You represent and warrant that You will not present a threat to the safety or security of
              Customers&apos; or others&apos; premises, person, guests, customers or employees.
            </p>

            <h2 className={styles.sectionHeader}>CUSTOMER DATA PRIVACY & COMPLIANCE</h2>
            <p className={styles.paragraph}>
              Customer privacy is of utmost importance. You are expected to exhibit complete respect of any and all
              Customer information. Customer information includes, but is not limited to, any information You collect or
              receive including but not limited to the customer&apos;s name, contact information, address/location,
              business, or any other personally identifiable information. You will not view or access any personal
              content on the Customer&apos;s device which is not necessary to provide services to Customer under this
              Agreement. This includes, but is not limited to, contacts, personal information, financial information,
              call or message histories, pictures or videos, emails, web histories, applications, or any other
              information not factory-installed on the device by the original equipment manufacturer and/or not required
              for the repair of the device.
            </p>
            <p className={`${styles.paragraph} ${styles.highlightText}`}>
              UNDER NO CIRCUMSTANCES SHOULD YOU EVER ACCESS, TRANSMIT, INSTALL, OR TRANSFER PERSONAL OR SENSITIVE DATA
              ON A CUSTOMER&apos;S DEVICE WITHOUT CUSTOMER&apos;S EXPRESS PERMISSION AND CONSENT. DOING SO VIOLATES THIS
              AGREEMENT AND WILL RESULT IN IMMEDIATE TERMINATION OF ANY RELATIONSHIP WITH FIXT, AS WELL AS POSSIBLE
              LEGAL ACTION AGAINST YOU BY FIXT, THE CUSTOMER, AND/OR GOVERNMENTAL AUTHORITIES.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

const styles = {
  mainTitle: 'text-3xl font-bold text-text-header mb-8',
  sectionHeader: 'text-2xl font-bold text-text-header mt-8 mb-4',
  paragraph: 'text-gray-700 leading-relaxed mb-6',
  paragraphShort: 'text-gray-700 leading-relaxed mb-4',
  listItem: 'text-gray-700',
  list: 'list-disc pl-8 mb-6 space-y-2',
  nestedList: 'list-disc pl-8 mt-2 space-y-1',
  dateText: 'text-sm text-gray-600 mb-4',
  highlightBox: 'bg-gray-100 p-4 rounded-lg mb-6',
  highlightText: 'text-gray-700 font-semibold',
};

export default TechAppTermsAndConditions;
